import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  FloatButton,
  Form,
  Image,
  Input,
  Popconfirm,
  Row,
  Select,
  Table,
  Tag,
  Tooltip,
  Skeleton,
  Dropdown,
  Modal,
  Alert,
} from "antd";
import AuthService from "../../Components/auth/AuthService";
import Message from "../../Components/common/Message";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import {
  AuthByRole,
  PostponeReasons,
  deliveryStatuses,
} from "../../Components/common/Constants";
import SignatureCanvas from "react-signature-canvas";
import { Checkbox as MUICheckbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Button as UploadButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import config, { env } from "../../Components/config";
import qs from "query-string";
import { ArrowLeftOutlined, CheckOutlined, CloseOutlined, InfoCircleOutlined, PhoneFilled, PhoneOutlined, PhoneTwoTone, QuestionCircleOutlined, RollbackOutlined, SyncOutlined } from "@ant-design/icons";
import PostponeModal from "../../Components/Modals/PostponeModal";
import PaymentDiscountModal from "../../Components/Modals/PaymentDiscountModal";
import QRCode from "react-qr-code";
import { v4 as uuidv4 } from 'uuid';
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import BankInfoModal from "../../Components/Modals/BankInfoModal";
import { formatCurrency } from "../../Components/common/CommonFun";


const Auth = new AuthService();

const useStyles = makeStyles((theme) => ({
  disableInputs: {
    "& .ant-input-outlined[disabled]": {
      background: "none",
      color: "black",
      fontWeight: "500",
    },
    "& .ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector ":
    {
      background: "white",
      color: "black",
    },
    "& .ant-checkbox-disabled+span": {
      color: "black"
    }
  },
  labels: {
    "& .ant-form-item-label": {
      fontWeight: "400",
      padding: "0 0 2px",
      // background: "#8582820a",
      color: "#979191",
    },
  },
  phone: {
    "& .ant-input-group >.ant-input": {
      height: '50px !important',

    },
  },
  payment: {
    "& .ant-form-item-label": {
      fontWeight: "500",
      padding: "0 0 2px",
      // background: "#8582820a",
      color: "#979191",
    },
    "& .ant-input-outlined[disabled]": {
      background: "none",
      color: "black",
      fontWeight: "500",
    },
  },
  postponeReason: {
    "& .ant-input-outlined[disabled]": {
      background: "white",
      fontWeight: 500,
      color: "black",
    },
    "& .ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector ":
    {
      background: "white",
      color: "black",
    },
    background: "#ed00007a",
    padding: "10px",
  },
  paymentMethods: {
    "& .ant-form-item-label": {
      fontWeight: "500",
      padding: "0 0 2px",
      color: "#979191",
    },
    "& .ant-input-outlined[disabled]": {
      background: "none",
      color: "black",
      fontWeight: "500",
    },
    "& .ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector ":
    {
      background: "white",
      color: "black",
    },
    "& .ant-checkbox-disabled+span": {
      color: "black"
    }
  },
  dataSheet: {
    "& .ant-checkbox .ant-checkbox-inner": {
      width: "36px",
      height: "38px",
    },
    "& .ant-checkbox+span": {
      fontSize: "16px",
      paddingTop: "4px",
    },
    "& .ant-checkbox-checked .ant-checkbox-inner:after": {
      width: "10px",
      height: "20px",
    },
    "& .ant-select-outlined.ant-select-disabled .ant-select-selector": {
      fontWeight: 500,
      background: "none",
      color: "black"
    },
    "& .ant-btn-primary:disabled": {
      color: "black"
    },
    "& .MuiFormControlLabel-label.Mui-disabled": {
      color: "black !important"
    },
    "& .MuiButtonBase-root-MuiCheckbox-root.Mui-disabled": {
      color: "black !important"
    },
    "& .ant-input-outlined[disabled]": {
      background: "none",
      color: "black",
      fontWeight: "500",
    },

  },
}));

const DeliveryItem = () => {
  const { pinValidity } = useSelector((state) => state.AppState?.driverData);
  const { selectedRoute } = useSelector((state) => state.AppState?.driverData);
  const { driverRoutes } = useSelector((state) => state?.AppState?.driverData);
  const selectedRouteData = driverRoutes.find((route) => route.id === selectedRoute);
  const [form] = Form.useForm();
  const classes = useStyles();
  const { TextArea } = Input;
  const { Option } = Select;
  const navigate = useNavigate();
  const location = useLocation();
  const selectedOrder = location?.state?.selectedOrder;
  console.log('selectedRouteData', selectedOrder)
  var layoutDispatch = useLoadingDispatch();
  const signatureCanvasRef = useRef(null);
  const dispatch = useDispatch();
  const securityPinExists = localStorage.getItem("securityPin");
  const deliveryDriverId = localStorage.getItem("driver_id");
  const readOnly = selectedRouteData?.start_status === 2 ? true : false;
  var layoutDispatch = useLoadingDispatch();

  const [deliveryQuantities, setDeliveryQuantities] = useState({});
  const [receivedPayment, setReceivedPayment] = useState("");
  const [orderCheckbox, setOrderCheckbox] = useState(false);
  const [recursiveAuthCall, setRecursiveAuthCall] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingBalance, setIsLoadingBalance] = useState(false);
  const [notes, setNotes] = useState("");
  const [paymentMode, setPaymentMode] = useState(1);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [signature, setSignature] = useState("");
  const [receiverName, setReceiverName] = useState("");
  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);

  const [disabledInputs, setDisabledInputs] = useState({});
  const [tableCheckbox, setTableCheckbox] = useState({});

  const [totalPaymentToBeReceived, setTotalPaymentToBeReceived] = useState(0);

  const [authBy, setAuthBy] = useState(null);
  const [paymentAuthBy, setPaymentAuthBy] = useState(null);
  const [deliveryChargeDiscount, setDeliveryChargeDiscount] = useState(false);


  const [accPayment, setAccPayment] = useState(0);
  const [cashPayment, setCashPayment] = useState(0);
  const [cardPayment, setCardPayment] = useState(0);

  const [accFullPayment, setAccFullPayment] = useState(false);
  const [cashFullPayment, setCashFullPayment] = useState(false);
  const [cardFullPayment, setCardFullPayment] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBankModalOpen, setBankIsModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [reason, setReason] = React.useState(null);
  const [postponedNotes, setPostponedNotes] = React.useState("");

  const [postponedfiles, setPostponedFiles] = useState([]);
  const [postponedCurrentItemFiles, setPostponedCurrentItemFiles] = useState(
    []
  );

  const [deliveryChargeStatus, setDeliveryChargeStatus] = React.useState("");
  const [paymentDiscountStatus, setPaymentDiscountStatus] = React.useState("");
  const [deliveryChargeNotes, setDeliveryChargeNotes] = React.useState("");
  const [paymentDiscountNotes, setPaymentDiscountNotes] = React.useState("");
  const [lessPayemntOption, setLessPayemntOption] = React.useState(false);

  const [shortPayment, setShortPaymnet] = React.useState(null);
  const [remainingAmount, setRemainingAmount] = React.useState(null);
  const [disableDiscountCheck, setDisableDiscountCheck] = React.useState(false);

  const [securityCode, setSecurityCode] = React.useState(null);
  const [showQR, setShowQR] = React.useState(false);

  const [paymentDiscountMethod, setPaymentDiscountMethod] = useState("");

  const [outStandingValue, setOutStandingValue] = useState(null);
  const [creditLimit, setCreditLimit] = useState(null);

  console.log('creditLimit', creditLimit);


  // Handle discount method change
  const handleDiscountMethodChange = (value) => {
    setPaymentDiscountMethod(value);
  };


  useEffect(() => {
    if (!selectedOrder) {
      navigate("/routes");
    }
  }, []);

  const handlePaymentTypeChange = (value, paymentType) => {
    switch (paymentType) {
      case "acc":
        setAccPayment(Number(value));
        break;
      case "cash":
        setCashPayment(Number(value));
        break;
      case "card":
        setCardPayment(Number(value));
        break;
      default:
        break;
    }
  };

  const handleFullPaymentCheckbox = (isChecked, paymentType) => {
    switch (paymentType) {
      case "acc":
        setAccFullPayment(isChecked);
        setCardFullPayment(false);
        setCashFullPayment(false);
        if (isChecked) {
          setAccPayment(totalPaymentToBeReceived);
          form.setFieldsValue({
            accPayment: totalPaymentToBeReceived,
            cardPayment: "",
            cashPayment: "",
          });
          setCashPayment(0);
          setCardPayment(0);
        } else {
          setAccPayment(0);
          form.setFieldsValue({
            accPayment: "",
          });
        }
        break;
      case "cash":
        setCashFullPayment(isChecked);
        setCardFullPayment(false);
        setAccFullPayment(false);
        if (isChecked) {
          setCashPayment(totalPaymentToBeReceived);
          form.setFieldsValue({
            cashPayment: totalPaymentToBeReceived,
            accPayment: "",
            cardPayment: "",
          });
          setCardPayment(0);
          setAccPayment(0);
        } else {
          setCashPayment(0);
          form.setFieldsValue({
            cashPayment: "",
          });
        }
        break;
      case "card":
        setCardFullPayment(isChecked);
        setCashFullPayment(false);
        setAccFullPayment(false);
        if (isChecked) {
          setCardPayment(totalPaymentToBeReceived);
          form.setFieldsValue({
            cardPayment: totalPaymentToBeReceived,
            cashPayment: "",
            accPayment: "",
          });
          setCashPayment(0);
          setAccPayment(0);
        } else {
          setCardPayment(0);
          form.setFieldsValue({
            cardPayment: "",
          });
        }
        break;
      default:
        break;
    }
  };

  const clearSignature = () => {
    signatureCanvasRef.current.clear();
    setSignature('')

  };

  const saveSignature = () => {
    const signatureImage = signatureCanvasRef.current.toDataURL();
    setSignature(signatureImage);
  };

  const handleCheckboxChange = (isChecked, itemPalletId) => {
    setDisabledInputs((prevState) => ({
      ...prevState,
      [itemPalletId]: isChecked,
    }));

    setTableCheckbox((prevState) => ({
      ...prevState,
      [itemPalletId]: isChecked,
    }));
  };

  const handleDeliveryQuantityChange = (value, record, commentId, flag) => {
    // const isFullQuantity = value === record.quantity;
    const isFullQuantity = value === record.packed_quantity;
    if (value === "full") {
      // value = record.quantity;
      value = record.packed_quantity;
      commentId = 12;
    }
    if (value === "notFull") {
      value = 0;
      commentId = null;
    }
    const updatedRecord = {
      ...deliveryQuantities[record.itemPalletId],
      delivered_quantity: value,
      // quantity: record?.quantity,
      quantity: record?.packed_quantity,
      delivery_status: commentId,
      item_code: record.itemCode,
      item_name: record?.itemName,
      item_internal_id: record?.item_internal_id,

      // unit_price: record?.unitPrice,
      unit_price: record?.unitPricePacked,
      item_weight: record?.item_weight,
      item_total_weight: record?.item_total_weight,
      gross_amount_incl_tax: record?.gross_amount_incl_tax,


    };

    setDeliveryQuantities((prevQuantities) => ({
      ...prevQuantities,
      [record.itemPalletId]: updatedRecord,
    }));

    const dataArray = [updatedRecord];

    if (flag) sendUpdateLine(dataArray);

    if (isFullQuantity) {
      setDisabledInputs((prevState) => ({
        ...prevState,
        [record.itemPalletId]: true,
      }));
      setTableCheckbox((prevState) => ({
        ...prevState,
        [record.itemPalletId]: true,
      }));
    }
  };

  console.log(deliveryQuantities, 'deliveryQuantities')

  const sendUpdateLine = async (record) => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    const dataToSend = {
      rec_arr: record
    }
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch("/driverapp/save-route-delivery-line", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (response.ack) {
        setLoadMessage("Record updated successfully." + str);
      } else {
        setLoadMessage("Failed to update record." + str);
      }
    } catch (error) {
      Message.error("An error occurred while updating please reapeat." + str);
    } finally {
      hideLoading(layoutDispatch);
    }
  };


  // const handleSelectAllFull = (event) => {
  //   const isChecked = event.target.checked;

  //   // Initialize new states for when checkbox is checked or unchecked
  //   const updatedDeliveryQuantities = {};
  //   const updatedCheckboxes = {};
  //   const updatedDisabledInputs = {};

  //   if (isChecked) {
  //     // Checkbox is checked: Set all items to "Full"
  //     selectedOrder?.items
  //       ?.filter((item) => item.itemCode !== "Delivery Charge")
  //       .forEach((record) => {
  //         // Set each item's checkbox to checked
  //         updatedCheckboxes[record.itemPalletId] = true;

  //         // Set the quantity to the full quantity (record.quantity)
  //         updatedDeliveryQuantities[record.itemPalletId] = {
  //           delivered_quantity: record.quantity,
  //           delivery_status: 12, // Assuming 12 is the 'full' status ID
  //         };

  //         // Disable the input for full quantity items
  //         updatedDisabledInputs[record.itemPalletId] = true;
  //       });
  //   } else {
  //     // Checkbox is unchecked: Reset all items to default (unchecked, no quantity)
  //     selectedOrder?.items
  //       ?.filter((item) => item.itemCode !== "Delivery Charge")
  //       .forEach((record) => {
  //         // Uncheck each item's checkbox
  //         updatedCheckboxes[record.itemPalletId] = false;

  //         // Reset the quantity to 0 or the initial state
  //         updatedDeliveryQuantities[record.itemPalletId] = {
  //           delivered_quantity: 0,
  //           delivery_status: null, // Or the default status
  //         };

  //         // Enable the input for unchecked items
  //         updatedDisabledInputs[record.itemPalletId] = false;
  //       });
  //   }

  //   // Update the states based on the checkbox action
  //   setDeliveryQuantities((prevState) => ({
  //     ...prevState,
  //     ...updatedDeliveryQuantities,
  //   }));

  //   setTableCheckbox((prevState) => ({
  //     ...prevState,
  //     ...updatedCheckboxes,
  //   }));

  //   setDisabledInputs((prevState) => ({
  //     ...prevState,
  //     ...updatedDisabledInputs,
  //   }));
  // };

  const handleSelectAllFull = (isChecked) => {
    const updatedQuantities = { ...deliveryQuantities };

    selectedOrder?.items?.filter((item) => item.itemCode !== "Delivery Charge").forEach((item) => {
      const existingData = deliveryQuantities[item.itemPalletId] || {};
      updatedQuantities[item.itemPalletId] = {
        ...existingData,
        // delivered_quantity: isChecked ? item.quantity : 0,  
        delivered_quantity: isChecked ? item.packed_quantity : 0,
        // quantity: item?.quantity,
        quantity: item?.packed_quantity,
        delivery_status: isChecked ? 12 : null,
        item_code: item?.itemCode,
        item_name: item?.itemName,
        item_internal_id: item?.item_internal_id,
        // unit_price: item?.unitPrice,
        unit_price: item?.unitPricePacked,
        item_weight: item?.item_weight,
        item_total_weight: item?.item_total_weight,
        gross_amount_incl_tax: item?.gross_amount_incl_tax,
      };
    });

    const updatedCheckboxes = {};
    const updatedDisabledInputs = {};

    selectedOrder?.items?.filter((item) => item.itemCode !== "Delivery Charge").forEach((item) => {
      updatedCheckboxes[item.itemPalletId] = isChecked;
      updatedDisabledInputs[item.itemPalletId] = isChecked;
    });

    // Update state
    setDeliveryQuantities(updatedQuantities);
    const records = Object.values(updatedQuantities)
    sendUpdateLine(records)
    console.log('new records', records);

    setTableCheckbox(updatedCheckboxes);
    setDisabledInputs(updatedDisabledInputs);
  };





  const calculateTotalPaymentToBeReceived = () => {
    let total = 0;
    if (selectedOrder) {
      selectedOrder.items.forEach((item) => {
        const deliveredQuantity =
          deliveryQuantities[item.itemPalletId]?.delivered_quantity || 0;
        // total += deliveredQuantity * item.unitPrice;
        total += deliveredQuantity * item.unitPricePacked;
        console.log(deliveredQuantity, '1111111');
      });


      const deliveryChargeItem = selectedOrder.items.find(
        (item) => item.itemCode === "Delivery Charge"
      );
      console.log(deliveryChargeItem, 'total deliveryChargeItem')

      if (deliveryChargeItem && (!deliveryChargeDiscount || (deliveryChargeDiscount && deliveryChargeStatus !== 2))) {
        total += deliveryChargeItem.unitPrice;
      }
    }

    console.log(total, 'totalAmount')
    setTotalPaymentToBeReceived(total.toFixed(2));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  useEffect(() => {
    calculateTotalPaymentToBeReceived();

  }, [deliveryQuantities, deliveryChargeDiscount]);

  const itemColumns = [
    {
      title: "S No.",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (text, record, index) => index + 1,
      width: 40,
    },
    {
      title: "Code",
      dataIndex: "itemCode",
      key: "itemCode",
      width: 40,
    },
    {
      title: "Name",
      dataIndex: "itemName",
      key: "itemName",
      width: 250,
    },
    {
      title: "QTY",
      dataIndex: "quantity",
      key: "quantity",
      width: 75,
    },
    {
      title: "Packed QTY",
      // dataIndex: "packed_quantity",
      // key: "packed_quantity",
      width: 75,
      render: (record) => {
        return (
          <span>{record?.packed_quantity || 0}</span>
        )
      },

    },
    // {
    //   title: "Unit Price",
    //   render: (record) => (
    //     <span>{`£${record?.unitPrice?.toFixed(2)}`}</span>
    //   ),
    //   width: 100,
    // },
    {
      title: "Delivered QTY",
      width: 100,
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            // justifyContent: "center",
          }}
          className={classes.disableInputs}

        >
          <Input
            type="number"
            size="large"
            style={{ width: "75px", marginRight: "5px" }}
            value={
              deliveryQuantities[record.itemPalletId]?.delivered_quantity || 0
            }
            disabled={readOnly || disabledInputs[record.itemPalletId] || selectedOrder?.delivered == 1 || selectedOrder?.delivered == -1}
            onChange={(e) => {
              const enteredValue = Math.max(0, Number(e.target.value)); // Ensure value is non-negative
              //TODO replace packed with quantity if deoplying on old format
              // const maxQuantity = record.quantity;
              const maxQuantity = record.packed_quantity;
              const newValue = enteredValue > maxQuantity ? maxQuantity : enteredValue;
              handleDeliveryQuantityChange(
                newValue,
                record,
                deliveryQuantities[record.itemPalletId]?.delivery_status,
                false
              );
            }}
          />
          <Checkbox
            checked={tableCheckbox[record.itemPalletId]}
            onChange={(e) => {
              const isChecked = e.target.checked;
              handleCheckboxChange(isChecked, record.itemPalletId);
              handleDeliveryQuantityChange(
                isChecked ? "full" : "notFull",
                record,
                deliveryQuantities[record.itemPalletId]?.delivery_status,
                true
              );
            }}
            disabled={readOnly || !selectedOrder?.delivered == 0}
          >
            Full
          </Checkbox>
        </div>
      ),
    },
    {
      title: "Status",
      width: 100,
      render: (record) => {
        const deliveryStatus =
          deliveryQuantities[record.itemPalletId]?.delivery_status;
        return (
          <Select
            style={{
              width: "100%",
            }}
            size="large"
            value={deliveryStatus}
            placeholder="Select Status"
            onChange={(value) =>
              handleDeliveryQuantityChange(
                deliveryQuantities[record.itemPalletId]?.delivered_quantity,
                record,
                value,
                true
              )
            }
            disabled={readOnly || !selectedOrder?.delivered == 0}
          >
            {deliveryStatuses.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        );
      },
    },
  ];


  const handleDelivereyCheckbox = (e) => {
    setOrderCheckbox(e.target.checked);
  };

  const handleWaveCharges = (e) => {
    setDeliveryChargeDiscount(e.target.checked);
    // if (e.target.checked) {
    //   let delivery_charge_item = selectedOrder?.items?.find(
    //     (item) => item.itemCode == "Delivery Charge"
    //   )
    //   if (delivery_charge_item?.unitPrice && deliveryChargeStatus === 2)
    //     setTotalPaymentToBeReceived((Number(totalPaymentToBeReceived) - (Number(delivery_charge_item.unitPrice) * Number(delivery_charge_item.quantity))).toFixed(2));
    // }
    // else {
    //   let delivery_charge_item = selectedOrder?.items?.find(
    //     (item) => item.itemCode == "Delivery Charge"
    //   )
    //   if (delivery_charge_item?.unitPrice && deliveryChargeStatus !== 2)
    //     setTotalPaymentToBeReceived((Number(totalPaymentToBeReceived) + (Number(delivery_charge_item.unitPrice) * Number(delivery_charge_item.quantity))).toFixed(2));
    // }
  };

  const getUploadUrl = async (file) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/route_orders/" + selectedRoute + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${file.name.split(".")[1]
        }`;
      setLoadMessage("");
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleSaveOrder = async () => {
    showLoading(layoutDispatch)
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }

    const deliveryChargeItem = selectedOrder?.items?.find((item) => item.itemCode == "Delivery Charge")

    // setIsLoading(true);
    const itemsArray = Object.values(deliveryQuantities);
    const dataToSend = {
      route_status_id: selectedRoute,
      notes: notes || "",
      delivery_driver_id: deliveryDriverId,
      items: itemsArray,
      internal_id: selectedOrder?.internalId,
      signature: signature,
      received_by: receiverName,
      files: currentItemFiles,
      deleted_files: deletedFiles,
      customer_internal_id: selectedOrder?.customer_internal_id,
      route_code: selectedRouteData?.route_code,
      delivery_discount: deliveryChargeDiscount ? 1 : 0,
      amount_received_account: accPayment ?? null,
      amount_received_cash: cashPayment ?? null,
      amount_received_card: cardPayment ?? null,
      sale_order_no: selectedOrder?.saleOrderNo,
      customer_code: selectedOrder?.customerCode,
      // delivery_charge_discount_auth_by: deliveryChargeDiscount ? authBy : '',
      payment_auth_by: paymentAuthBy || '',
    }

    if (deliveryChargeItem) {
      dataToSend.delivery_charge_quantity = deliveryChargeItem.quantity
    }

    try {
      const res = await Auth.fetch("/driverapp/save-route-delivery", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        const uploadPromises = files.map(async (f) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            setLoadMessage("Error uploading file:");
            setType("error");
            console.error("Error uploading file:", error);
          }
        });
        Promise.all(uploadPromises).then(() => {

          navigate("/routes");
          hideLoading(layoutDispatch)
        });
      } else {
        setType('error')
        setLoadMessage(res.message)
        hideLoading(layoutDispatch)
      }
    } catch (err) {
      setType('error')
      setLoadMessage("something went wrong, Please try again " + str)
      console.log(err);
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleSaveDeliveredOrder = async () => {
    showLoading(layoutDispatch)
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }

    const dataToSend = {
      notes: notes || "",
      internal_id: selectedOrder?.internalId,
      signature: signature,
      received_by: receiverName,
      files: currentItemFiles,
    }


    try {
      const res = await Auth.fetch("/driverapp/save-route-delivery-delivered", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        const uploadPromises = files.map(async (f) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            setLoadMessage("Error uploading file:");
            setType("error");
            console.error("Error uploading file:", error);
          }
        });
        Promise.all(uploadPromises).then(() => {

          navigate("/routes");
          hideLoading(layoutDispatch)
        });
      } else {
        setType('error')
        setLoadMessage(res.message)
        hideLoading(layoutDispatch)
      }
    } catch (err) {
      setType('error')
      setLoadMessage("something went wrong, Please try again " + str)
      console.log(err);
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  useEffect(() => {
    const totalPaymentReceived = parseFloat(accPayment) + parseFloat(cashPayment) + parseFloat(cardPayment);
    const lessPayment = parseFloat(totalPaymentToBeReceived) > totalPaymentReceived
    console.log('lessPayment', lessPayment)
    setShortPaymnet(lessPayment)
  }, [totalPaymentToBeReceived, accPayment, cashPayment, cardPayment])

  useEffect(() => {
    const amountCollected = parseFloat(accPayment) + parseFloat(cashPayment) + parseFloat(cardPayment);
    const lessPayment = parseFloat(totalPaymentToBeReceived) - amountCollected
    const amount = lessPayment < 0 ? `+${-lessPayment.toFixed(2)}` : lessPayment.toFixed(2)
    setRemainingAmount(amount)
  }, [totalPaymentToBeReceived, accPayment, cashPayment, cardPayment])

  console.log('short', shortPayment)

  const handleDelivered = async (deliverStatus) => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }

    const totalPaymentReceived = parseFloat(accPayment) + parseFloat(cashPayment) + parseFloat(cardPayment);
    const lessPayment = parseFloat(totalPaymentToBeReceived) > totalPaymentReceived
    console.log('lessPayment', totalPaymentReceived)

    // const itemsWithMissingStatus = Object.values(deliveryQuantities).filter(
    //   (quantity) => {
    //     return quantity.delivered_quantity > 0 && !quantity.delivery_status;
    //   }
    // );

    // if (itemsWithMissingStatus.length > 0) {
    //   const missingSerialNumbers = itemsWithMissingStatus
    //     .map(
    //       (item) =>
    //         selectedOrder.items.findIndex(
    //           (orderItem) => orderItem.itemPalletId === item.item_pallet_id
    //         ) + 1
    //     )
    //     .join(", ");
    //   setType("error");
    //   setLoadMessage(
    //     `Please select the required status for the following line No: ${missingSerialNumbers}${str}`
    //   );
    //   return;
    // }

    const itemsWithMissingStatus = Object.values(deliveryQuantities).filter(
      (quantity) => {
        return quantity.delivered_quantity >= 0 && !quantity.delivery_status;
      }
    );

    if (itemsWithMissingStatus.length > 0) {
      console.log('itemsWithMissingStatus', itemsWithMissingStatus)
      const missingItemCodes = itemsWithMissingStatus
        .map(
          (item) => {
            const orderItem = selectedOrder.items.find(
              (orderItem) => orderItem.itemPalletId === item.item_pallet_id
            );
            return orderItem ? orderItem.itemCode : null;
          }
        )
        .filter(Boolean)
        .join(", ");
      setType("error");
      setLoadMessage(
        `Please select the required status for the following items: ${missingItemCodes}${str}`
      );
      return;
    }

    if (shortPayment && paymentDiscountStatus != 1 && paymentDiscountStatus != 2 && paymentDiscountStatus != 3 && (selectedOrder?.terms === "Cash on Delivery - C" || selectedOrder?.terms === "Cash on Delivery")) {
      setType('error');
      setLoadMessage(`Total amount to be paid is ${'£' + totalPaymentToBeReceived} and you are receiving ${'£' + totalPaymentReceived}, Please click on 'Request Payment Discount' button for approval ` + str);
      return
    }

    if (!signature) {
      setType("error");
      setLoadMessage("Please sign before saving" + str);
      return;
    }
    if (!receiverName) {
      setType("error");
      setLoadMessage("Please enter the receiver Name first" + str);
      return;
    }
    if (receiverName && receiverName.length < 3) {
      setType("error");
      setLoadMessage("The receiver's name should be three characters long." + str);
      return;
    }

    // if (!currentItemFiles.length) {
    //   setType("error");
    //   setLoadMessage("Please add at least one image to proceed" + str);
    //   return;
    // }

    const itemsArray = Object.values(deliveryQuantities);
    const delivery_date = localStorage.getItem("delivery_date")

    const hasDeliveredItem = itemsArray.some((item) => item.delivered_quantity > 0);

    if (!hasDeliveredItem) {
      setType("error");
      setLoadMessage("The order cannot be delivered because all items have a zero quantity. Please postpone the order with a relevant reason." + str);
      return;
    }

    const deliveryChargeItem = selectedOrder?.items?.find((item) => item.itemCode == "Delivery Charge")

    const deliveryStatusCheckCOD = deliverStatus && (selectedOrder?.terms === "Cash on Delivery - C" || selectedOrder?.terms === "Cash on Delivery") && (paymentDiscountStatus === 2 || !shortPayment ? "1" : "0")
    const deliveryStatusCheckNotCOD = deliverStatus && (selectedOrder?.terms !== "Cash on Delivery - C" || selectedOrder?.terms === "Cash on Delivery") ? "1" : "0"
    console.log('NodeliveryStatusCheck', deliveryStatusCheckNotCOD)
      // showLoading(layoutDispatch);
      ;

    const email = env === 'prod' ? customerEmail : 'jibran@magnafoodservice.co.uk'
    const emailPayloadProd = {
      customer_email: email,
      internal_id: selectedOrder?.internalId,
      delivery_date: delivery_date
    };
    const dataToSend = {
      route_status_id: selectedRoute,
      notes: notes || "",
      delivered: (selectedOrder?.terms === "Cash on Delivery - C" || selectedOrder?.terms === "Cash on Delivery") ? deliveryStatusCheckCOD : deliveryStatusCheckNotCOD,
      delivery_driver_id: deliveryDriverId,
      items: itemsArray,
      internal_id: selectedOrder?.internalId,
      signature: signature,
      received_by: receiverName,
      files: currentItemFiles,
      deleted_files: deletedFiles,
      customer_internal_id: selectedOrder?.customer_internal_id,
      route_code: selectedRouteData?.route_code,
      delivery_discount: deliveryChargeDiscount ? 1 : 0,
      amount_received_account: accPayment ?? null,
      amount_received_cash: cashPayment ?? null,
      amount_received_card: cardPayment ?? null,

      sale_order_no: selectedOrder?.saleOrderNo,
      customer_code: selectedOrder?.customerCode,
      credit_limit: creditLimit ? creditLimit : '',
      customer_balance: outStandingValue ? outStandingValue : '',
      // delivery_charge_discount_auth_by: deliveryChargeDiscount ? authBy : '',
      // payment_auth_by: lessPayment ? paymentAuthBy : '',
    }

    if (deliveryChargeItem) {
      dataToSend.delivery_charge_quantity = deliveryChargeItem.quantity
    }

    try {
      showLoading(layoutDispatch);
      const res = await Auth.fetch("/driverapp/save-route-delivery", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        const uploadPromises = files.map(async (f) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            setLoadMessage("Error uploading file:");
            setType("error");
            console.error("Error uploading file:", error);
          }
        });
        Promise.all(uploadPromises).then(async () => {
          console.log('deliveryStatusCheckCOD', deliveryStatusCheckCOD);
          if (deliverStatus && deliveryStatusCheckCOD == 0 && (selectedOrder?.terms === "Cash on Delivery - C" || selectedOrder?.terms === "Cash on Delivery")) {
            setType('error')
            setLoadMessage('Order Can not be delivered. You are collecting less money' + str)
            setTimeout(() => {
              navigate("/routes");
            }, 2000);
          }


          if (env === "prod") {
            fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/order-receipt", {
              method: "POST",
              headers: {
                Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(emailPayloadProd),
            }).catch((err) => console.error("Error sending email:", err));
          } else if (env === "dev") {

            fetch("http://localhost:7420/api/email/order-receipt", {
              method: "POST",
              headers: {
                Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI3ODgwNDE0LCJleHAiOjE3NTk0MTY0MTQsImF1ZCI6Imh0dHBzOi8vd3d3Lm1hZ25hZm9vZHNlcnZpY2UuY28udWsvIiwiaXNzIjoiTWFnbmEgRm9vZCBTZXJ2aWNlIiwic3ViIjoibm9vckBnbWFpbC5jb20ifQ.Bidb4jyOqnI4JdF9o0WpcEqiGQDpxv47KZ2mFyhFhLwj0LSui0ukFFH889J3tdVs3A-8ah-rk5026bfhEpneyUzkPl0IEE1iTBt4rdmXnUytXQRY38AsSiMv_v0S1gFL0JJtMh2Odzh3JpPbALaqEhCX0P2Kvhy9jNeczzWL8-rYw9b9WVgVN_mBd8AcdzgbzbeVOPd9hDL24im5QXwd6wIT9hme3e-lyBvW24bEp-ozxwaujVAZrtdh8BoSTTD2lyn0nKHc7iErGFjhFvtIw2pzvtnorNzfWJ2hB2BABQ0JOruxnxVks7NbNAMyBhchQhGV5af6ssDAZ4YaKUeNpw",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(emailPayloadProd),
            }).catch((err) => console.error("Error sending email:", err));
          } else {
            fetch("http://34.197.161.10:7420/api/email/order-receipt", {
              method: "POST",
              headers: {
                Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAbWFnbmFmb29kc2VydmljZS5jby51ayIsInVzZXJfaWQiOjEsImlhdCI6MTczNTU1OTM3NywiYXVkIjoiaHR0cHM6Ly93d3cubWFnbmFmb29kc2VydmljZS5jby51ay8iLCJpc3MiOiJNYWduYSBGb29kIFNlcnZpY2UiLCJzdWIiOiJub29yQG1hZ25hZm9vZHNlcnZpY2UuY28udWsifQ.ZC9_oBo2jQAz9EKCn19KD17WzMaVQPjuUUWhSBfDPPnaqb18j4cILaJIJUYgVprjjAGIzxUBt4Ln7do3br5Ps1nzkShjVrptne_eop_rxqcJCHnaIlra0UQnFsiTBJ8V_5GanQAQIVbuKwFlcpqJCb5adCeE5OipBANSURekGyMXSeYos4dVjrZu7g7DD8sxCWkePVW_LhlndbytgdkazRmOkHNmnq5x9bnO16fMAAPm1nMVxluC5bGJzJqCYhmnO-UlV6ZpAdCACS0ZW7tylwc2foEtkLz7jUE8X7hHUGCYfRO2N7gMcqKqBYgbf6DV5HEgsDFoEoGlxGjERqGjCQ",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(emailPayloadProd),
            }).catch((err) => console.error("Error sending email:", err));
          }
          navigate("/routes");
          hideLoading(layoutDispatch)
        });
      } else {
        setType('error')
        setLoadMessage(res.message)
        hideLoading(layoutDispatch)
      }
    } catch (err) {
      setType('error')
      setLoadMessage("something went wrong, Please try again " + str)
      console.log(err);
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  console.log(deliveryQuantities, 'deliveryQuantities')

  const requestDeliveryChargeDiscount = async (type) => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    const dataToSend = {
      type: type,
      internal_id: selectedOrder?.internalId,
      notes: notes,
    }
    // if(type == 1 && !notes) {
    //   setType('error')
    //   setLoadMessage('Please Enter Notes to continue' + str)
    //   return
    // }
    // if(type == 1) dataToSend.notes = notes;
    try {
      const res = await Auth.fetch("/driverapp/send-payment-authorization", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {

        if (type == 1) {
          setDeliveryChargeStatus(1);
          setDeliveryChargeDiscount(true);
          const messagePayload = {
            driver_name: selectedRouteData?.driver_name,
            route_name: selectedRouteData?.route,
            invoice_no: selectedOrder?.invoiceNo ? selectedOrder?.invoiceNo : selectedOrder?.saleOrderNo,
            customer_name: selectedOrder?.customerName + " (" + selectedOrder?.customerCode + ")",
            authorizers: selectedOrder?.paymentAuthorizer
          };
          const emailPayload = {
            driver_name: selectedRouteData?.driver_name,
            route_name: selectedRouteData?.route,
            invoice_no: selectedOrder?.invoiceNo ? selectedOrder?.invoiceNo : selectedOrder?.saleOrderNo,
            customer_name: selectedOrder?.customerName + " (" + selectedOrder?.customerCode + ")",
            inv_internal_id: selectedOrder?.inv_internal_id,
            customerCode: selectedOrder?.customerCode,
            customer_internal_id: selectedOrder?.customer_internal_id,
            type: type,
            internal_id: selectedOrder?.internalId,
            subject: "Delivery Discount"
          };

          try {
            const messageApiResponse = await fetch("https://promotions.api-magnafoodservice.co.uk/api/send-tms-delivery-discount-notifications", {
              method: "POST",
              headers: {
                Authorization: "Bearer 5|YzMkDJ11kIbbabpv1atryJYb6CETFCbRJY8i9QOs",
                "Content-Type": "application/json"
              }, body: JSON.stringify(messagePayload)
            });

            if (messageApiResponse.ok === true) {

              setRecursiveAuthCall(!recursiveAuthCall);

              setLoadMessage("Message sent on WhatsApp")
              setType('success')
            } else {
              setLoadMessage("Message Sendind Failure")
              setType('error')
            }

          } catch (messageError) {
            console.log(messageError);

          } finally {
            // try {
            //   //Production url and token for email
            //   const EmailApiResponse = await fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/discounts", {
            //     method: "POST",
            //     headers: {
            //       Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
            //       "Content-Type": "application/json"
            //     }, 
            //     body: JSON.stringify(emailPayload)
            //   });  


            //   if (EmailApiResponse.ok === true) {


            //     setLoadMessage("Email sent ")
            //     setType('success')
            //   } else {
            //     setLoadMessage("Email Sendind Failure")
            //     setType('error')
            //   }

            // } catch (err) {
            //   console.log(err);
            // }
            if (env === "prod") {
              fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/discounts", {
                method: "POST",
                headers: {
                  Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(emailPayload),
              }).catch((err) => console.error("Error sending email:", err));
            } else if (env === "dev") {

              fetch("http://localhost:7420/api/email/discounts", {
                method: "POST",
                headers: {
                  Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI3ODgwNDE0LCJleHAiOjE3NTk0MTY0MTQsImF1ZCI6Imh0dHBzOi8vd3d3Lm1hZ25hZm9vZHNlcnZpY2UuY28udWsvIiwiaXNzIjoiTWFnbmEgRm9vZCBTZXJ2aWNlIiwic3ViIjoibm9vckBnbWFpbC5jb20ifQ.Bidb4jyOqnI4JdF9o0WpcEqiGQDpxv47KZ2mFyhFhLwj0LSui0ukFFH889J3tdVs3A-8ah-rk5026bfhEpneyUzkPl0IEE1iTBt4rdmXnUytXQRY38AsSiMv_v0S1gFL0JJtMh2Odzh3JpPbALaqEhCX0P2Kvhy9jNeczzWL8-rYw9b9WVgVN_mBd8AcdzgbzbeVOPd9hDL24im5QXwd6wIT9hme3e-lyBvW24bEp-ozxwaujVAZrtdh8BoSTTD2lyn0nKHc7iErGFjhFvtIw2pzvtnorNzfWJ2hB2BABQ0JOruxnxVks7NbNAMyBhchQhGV5af6ssDAZ4YaKUeNpw",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(emailPayload),
              }).catch((err) => console.error("Error sending email:", err));
            } else {
              fetch("http://34.197.161.10:7420/api/email/discounts", {
                method: "POST",
                headers: {
                  Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAbWFnbmFmb29kc2VydmljZS5jby51ayIsInVzZXJfaWQiOjEsImlhdCI6MTczNTU1OTM3NywiYXVkIjoiaHR0cHM6Ly93d3cubWFnbmFmb29kc2VydmljZS5jby51ay8iLCJpc3MiOiJNYWduYSBGb29kIFNlcnZpY2UiLCJzdWIiOiJub29yQG1hZ25hZm9vZHNlcnZpY2UuY28udWsifQ.ZC9_oBo2jQAz9EKCn19KD17WzMaVQPjuUUWhSBfDPPnaqb18j4cILaJIJUYgVprjjAGIzxUBt4Ln7do3br5Ps1nzkShjVrptne_eop_rxqcJCHnaIlra0UQnFsiTBJ8V_5GanQAQIVbuKwFlcpqJCb5adCeE5OipBANSURekGyMXSeYos4dVjrZu7g7DD8sxCWkePVW_LhlndbytgdkazRmOkHNmnq5x9bnO16fMAAPm1nMVxluC5bGJzJqCYhmnO-UlV6ZpAdCACS0ZW7tylwc2foEtkLz7jUE8X7hHUGCYfRO2N7gMcqKqBYgbf6DV5HEgsDFoEoGlxGjERqGjCQ",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(emailPayload),
              }).catch((err) => console.error("Error sending email:", err));
            }
          }

        }

        else {
          const messagePayload = {
            driver_name: selectedRouteData?.driver_name,
            route_name: selectedRouteData?.route,
            invoice_no: selectedOrder?.invoiceNo ? selectedOrder?.invoiceNo : selectedOrder?.saleOrderNo,
            customer_name: selectedOrder?.customerName + " (" + selectedOrder?.customerCode + ")",
            authorizers: selectedOrder?.paymentAuthorizer
          };
          const emailPayload = {
            driver_name: selectedRouteData?.driver_name,
            route_name: selectedRouteData?.route,
            invoice_no: selectedOrder?.invoiceNo ? selectedOrder?.invoiceNo : selectedOrder?.saleOrderNo,
            customer_name: selectedOrder?.customerName + " (" + selectedOrder?.customerCode + ")",
            inv_internal_id: selectedOrder?.inv_internal_id,
            customerCode: selectedOrder?.customerCode,
            customer_internal_id: selectedOrder?.customer_internal_id,
            subject: 'Payment Discount',
            type: type,
            internal_id: selectedOrder?.internalId,
          };
          try {
            const messageApiResponse = await fetch("https://promotions.api-magnafoodservice.co.uk/api/send-tms-payment-authorization-notifications", {
              method: "POST",
              headers: {
                Authorization: "Bearer 5|YzMkDJ11kIbbabpv1atryJYb6CETFCbRJY8i9QOs",
                "Content-Type": "application/json"
              }, body: JSON.stringify(messagePayload)
            });

            if (messageApiResponse.ok === true) {
              setLoadMessage("Message sent on WhatsApp")
              setType('success')
            } else {
              setLoadMessage("Message Sendind Failure")
              setType('error')
            }

          } catch (err) {
            console.log(err);
          } finally {
            // try {
            //   const EmailApiResponse = await fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/discounts", {
            //     method: "POST",
            //     headers: {
            //       Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
            //       "Content-Type": "application/json"
            //     }, 
            //     body: JSON.stringify(emailPayload)
            //   });



            //   if (EmailApiResponse.ok === true) {


            //     setLoadMessage("Email sent ")
            //     setType('success')
            //   } else {
            //     setLoadMessage("Email Sendind Failure")
            //     setType('error')
            //   }

            // } catch (err) {
            //   console.log(err);
            // }

            if (env === "prod") {
              fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/discounts", {
                method: "POST",
                headers: {
                  Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(emailPayload),
              }).catch((err) => console.error("Error sending email:", err));
            } else if (env === "dev") {

              fetch("http://localhost:7420/api/email/discounts", {
                method: "POST",
                headers: {
                  Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI3ODgwNDE0LCJleHAiOjE3NTk0MTY0MTQsImF1ZCI6Imh0dHBzOi8vd3d3Lm1hZ25hZm9vZHNlcnZpY2UuY28udWsvIiwiaXNzIjoiTWFnbmEgRm9vZCBTZXJ2aWNlIiwic3ViIjoibm9vckBnbWFpbC5jb20ifQ.Bidb4jyOqnI4JdF9o0WpcEqiGQDpxv47KZ2mFyhFhLwj0LSui0ukFFH889J3tdVs3A-8ah-rk5026bfhEpneyUzkPl0IEE1iTBt4rdmXnUytXQRY38AsSiMv_v0S1gFL0JJtMh2Odzh3JpPbALaqEhCX0P2Kvhy9jNeczzWL8-rYw9b9WVgVN_mBd8AcdzgbzbeVOPd9hDL24im5QXwd6wIT9hme3e-lyBvW24bEp-ozxwaujVAZrtdh8BoSTTD2lyn0nKHc7iErGFjhFvtIw2pzvtnorNzfWJ2hB2BABQ0JOruxnxVks7NbNAMyBhchQhGV5af6ssDAZ4YaKUeNpw",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(emailPayload),
              }).catch((err) => console.error("Error sending email:", err));
            } else {
              fetch("http://34.197.161.10:7420/api/email/discounts", {
                method: "POST",
                headers: {
                  Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAbWFnbmFmb29kc2VydmljZS5jby51ayIsInVzZXJfaWQiOjEsImlhdCI6MTczNTU1OTM3NywiYXVkIjoiaHR0cHM6Ly93d3cubWFnbmFmb29kc2VydmljZS5jby51ay8iLCJpc3MiOiJNYWduYSBGb29kIFNlcnZpY2UiLCJzdWIiOiJub29yQG1hZ25hZm9vZHNlcnZpY2UuY28udWsifQ.ZC9_oBo2jQAz9EKCn19KD17WzMaVQPjuUUWhSBfDPPnaqb18j4cILaJIJUYgVprjjAGIzxUBt4Ln7do3br5Ps1nzkShjVrptne_eop_rxqcJCHnaIlra0UQnFsiTBJ8V_5GanQAQIVbuKwFlcpqJCb5adCeE5OipBANSURekGyMXSeYos4dVjrZu7g7DD8sxCWkePVW_LhlndbytgdkazRmOkHNmnq5x9bnO16fMAAPm1nMVxluC5bGJzJqCYhmnO-UlV6ZpAdCACS0ZW7tylwc2foEtkLz7jUE8X7hHUGCYfRO2N7gMcqKqBYgbf6DV5HEgsDFoEoGlxGjERqGjCQ",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(emailPayload),
              }).catch((err) => console.error("Error sending email:", err));
            }
          }

        }
        setType('success');
        setLoadMessage(res.message)
      } else {
        setType('error');
        setLoadMessage(res.message)
      }
    } catch (err) {
      console.log(err);
    }
  }

  const getDeliveryChargeDiscountInfo = async () => {
    try {
      if (deliveryChargeStatus == 1) {
        const res = await Auth.fetch(`/driverapp/get-payment-authorization-status?internal_id=${selectedOrder?.internalId}`);
        if (res?.ack) {
          const response = res?.payment_auth_status;
          setDeliveryChargeStatus(response?.delivery_discount_req_status)
          if (response?.delivery_discount_req_status === 2) {
            let delivery_charge_item = selectedOrder?.items?.find(
              (item) => item.itemCode == "Delivery Charge"
            )
            if (delivery_charge_item?.unitPrice && response?.delivery_discount_req_status === 2)
              setTotalPaymentToBeReceived((Number(totalPaymentToBeReceived) - (Number(delivery_charge_item.unitPrice) * Number(delivery_charge_item.quantity))).toFixed(2));

          }
          setDeliveryChargeNotes(response?.delivery_discount_req_notes)
          setAuthBy(response?.delivery_discount_auth_by == 0 ? null : response?.delivery_discount_auth_by)
          setPaymentDiscountStatus(response?.payment_req_status)
          setPaymentDiscountNotes(response?.payment_req_notes)
          setPaymentAuthBy(response?.payment_auth_by)
        } else {
          setType('error');
          setLoadMessage(res.message)
        }
      }
      if (paymentDiscountStatus == 1 && (selectedOrder?.terms === "Cash on Delivery - C" || selectedOrder?.terms === "Cash on Delivery")) {
        const res = await Auth.fetch(`/driverapp/get-payment-authorization-status?internal_id=${selectedOrder?.internalId}`);
        if (res?.ack) {
          const response = res?.payment_auth_status;
          setDeliveryChargeStatus(response?.delivery_discount_req_status)
          setDeliveryChargeNotes(response?.delivery_discount_req_notes)
          setAuthBy(response?.delivery_discount_auth_by == 0 ? null : response?.delivery_discount_auth_by)
          setPaymentDiscountStatus(response?.payment_req_status)
          setPaymentDiscountNotes(response?.payment_req_notes)
          setPaymentAuthBy(response?.payment_auth_by)
        } else {
          setType('error');
          setLoadMessage(res.message)
        }
      }
    } catch (err) {
      console.log(err);
    }

  }

  useEffect(() => {
    const interval = setInterval(() => {
      getDeliveryChargeDiscountInfo();
    }, 10000);
    return () => clearInterval(interval);
  }, [recursiveAuthCall, deliveryChargeStatus, paymentDiscountStatus, totalPaymentToBeReceived])


  if (!pinValidity) {
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    navigate("/pin");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  if (!securityPinExists) {
    navigate("/pin");
    localStorage.removeItem("DriverName");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    dispatch({ type: "RESET_STATE" });
    localStorage.setItem('routeLocation', false)
  }

  const generateRandomString = () => {
    const uuid = uuidv4()
    // let randomString = '';
    // while (randomString.length < 20) {
    //   randomString += Math.random().toString(36).substring(2);
    // }
    // return randomString.substring(0, 20);
    return uuid;
  };

  const postSecurityCode = async (internalID, code) => {
    const dataToSend = {
      internal_id: internalID,
      security_code: code
    }
    try {
      const res = await Auth.fetch("/driverapp/save-order-security-code", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        setSecurityCode(code);
        setShowQR(true)
      }

    } catch (err) {
      console.log(err);
    }

  }
  const [customerEmail, setCustomerEmail] = useState(null)

  useEffect(() => {
    if (selectedOrder) {
      const newCustomerValues = selectedOrder?.customerInfo?.split("######");
      setCustomerEmail(newCustomerValues?.[6] && newCustomerValues[6] !== '-' ? newCustomerValues[6] : '')
      console.log('newCustomerValues', newCustomerValues);

      form.setFieldsValue({
        invoiceNo: selectedOrder?.invoiceNo ? selectedOrder?.invoiceNo : selectedOrder?.saleOrderNo,
        shopCode: selectedOrder.customerCode,
        customerName: selectedOrder.customerName,
        address: selectedOrder.address,
        postCode: selectedOrder.postCode,
        total: selectedOrder.orderValue?.toFixed(2),
        terms: selectedOrder.terms,
        deliveryInstructions: selectedOrder.deliveryInstructions || "",
        accPayment: selectedOrder.amountReceivedAccount
          ? selectedOrder.amountReceivedAccount.toFixed(2)
          : "",
        cardPayment: selectedOrder.amountReceivedCard
          ? selectedOrder.amountReceivedCard.toFixed(2)
          : "",
        cashPayment: selectedOrder.amountReceivedCash
          ? selectedOrder.amountReceivedCash.toFixed(2)
          : "",
        deliveryContact: newCustomerValues?.[1] && newCustomerValues[1] !== '-' ? newCustomerValues[1] : '',
        customerContact: newCustomerValues?.[0] && newCustomerValues[0] !== '-' ? newCustomerValues[0] : '',
        whatsappContact: newCustomerValues?.[2] && newCustomerValues[2] !== '-' ? newCustomerValues[2] : '',
        instructionsDelivery: newCustomerValues?.[3] && newCustomerValues[3] !== '-' ? newCustomerValues[3] : '',
        instructionsParking: newCustomerValues?.[4] && newCustomerValues[4] !== '-' ? newCustomerValues[4] : '',
        instructionsPayment: newCustomerValues?.[5] && newCustomerValues[5] !== '-' ? newCustomerValues[5] : '',


      });
      setNotes(selectedOrder.notes);
      setAuthBy(selectedOrder?.deliveryChargeDiscountAuthBy == 0 ? null : selectedOrder?.deliveryChargeDiscountAuthBy)
      setPaymentAuthBy(selectedOrder?.deliveryPaymentDiscountAuthBy == 0 ? null : selectedOrder?.deliveryPaymentDiscountAuthBy)
      setPostponedNotes(selectedOrder?.postponedNotes);
      setReason(selectedOrder?.postponedStatus);
      setAccPayment(
        selectedOrder.amountReceivedAccount
          ? selectedOrder.amountReceivedAccount.toFixed(2)
          : 0
      );
      setCardPayment(
        selectedOrder.amountReceivedCard
          ? selectedOrder.amountReceivedCard.toFixed(2)
          : 0
      );
      setCashPayment(
        selectedOrder.amountReceivedCash
          ? selectedOrder.amountReceivedCash.toFixed(2)
          : 0
      );
      setSignature(selectedOrder.signature);
      setReceiverName(selectedOrder.receivedBy);
      setCurrentItemFiles(JSON.parse(selectedOrder.files) || []);
      setPostponedCurrentItemFiles(selectedOrder?.postponedFiles ? JSON.parse(selectedOrder?.postponedFiles) : []);
      setDeliveryChargeStatus(selectedOrder?.deliveryChargeDiscountStatus)
      setPaymentDiscountStatus(selectedOrder?.paymentDiscountStatus)
      // setPaymentDiscountStatus(null)
      setPaymentDiscountNotes(selectedOrder?.paymentDiscountNotes)
      setDeliveryChargeNotes(selectedOrder?.deliveryChargeDiscountNotes)
      setOrderCheckbox(selectedOrder.delivered == 1 ? true : false);
      setDeliveryChargeDiscount(selectedOrder.deliveryDiscount == 1 ? true : false)

      setRecursiveAuthCall(!recursiveAuthCall);

      if (selectedOrder?.security_code != null) {
        setSecurityCode(selectedOrder?.security_code)
        setShowQR(true)
        console.log('if');
      } else {
        const code = generateRandomString();
        // setSecurityCode(code)
        postSecurityCode(selectedOrder?.internalId, code)

      };


      const initialDeliveryQuantities = {};
      const filteredItems = selectedOrder?.items?.filter(
        (item) => item.itemCode !== "Delivery Charge"
      )
      filteredItems.forEach((item) => {
        initialDeliveryQuantities[item.itemPalletId] = {
          item_pallet_id: item.itemPalletId,
          delivered_quantity: item.deliveredQuantity || 0,
          // quantity: item.quantity || 0,
          quantity: item.packed_quantity || 0,
          delivery_status: item.deliveryStatus,
          item_code: item?.itemCode,
          item_name: item?.itemName,
          item_internal_id: item?.item_internal_id,
          // unit_price: item?.unitPrice,
          unit_price: item?.unitPricePacked,
          item_weight: item?.item_weight,
          item_total_weight: item?.item_total_weight,
          gross_amount_incl_tax: item?.gross_amount_incl_tax,
        };

        // if (item.deliveredQuantity === item.quantity) {
        if (item.deliveredQuantity === item.packed_quantity) {
          setDisabledInputs((prevState) => ({
            ...prevState,
            [item.itemPalletId]: true,
          }));
          setTableCheckbox((prevState) => ({
            ...prevState,
            [item.itemPalletId]: true,
          }));
        }
      });
      setDeliveryQuantities(initialDeliveryQuantities);
    }
  }, [selectedOrder]);


  console.log('securityCode', securityCode);

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const unpostponeOrder = async () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }

    setIsLoading(true);
    const unPostponeData = {
      route_status_id: selectedRoute,
      postponed_notes: "",
      delivered: 0,
      internal_id: selectedOrder?.internalId,
      postponed_files: [],
      postponed_status: "",
    };

    try {
      const res = await Auth.fetch("/driverapp/change-order-postponed-status", {
        method: "POST",
        body: JSON.stringify(unPostponeData),
      });
      if (res?.ack) {
        navigate("/routes");
        setLoadMessage(res?.message);
        setType("success");
      } else {
        setLoadMessage(res?.message);
        setType("error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitImagePostpone = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${file.name.split(".")[1]
        }`;
      setLoadMessage("");
      setPostponedFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setPostponedCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFilePostpone = (fileName) => {
    const updatedFiles = postponedfiles?.filter((file) => file.name !== fileName);
    setPostponedFiles(updatedFiles);
    setPostponedCurrentItemFiles(postponedCurrentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFilePostpone = (itemToDelete) => {
    setPostponedCurrentItemFiles(
      postponedCurrentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrlPostpone = async (file) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/postpone_order/" + selectedRoute + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3Postpone = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const handleOk = async () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }

    if (!reason) {
      setType("error");
      setLoadMessage(`Please select reason for postponment ${str}`);
      return;
    }

    setIsLoading(true)
    const postponeData = {
      route_status_id: selectedRoute,
      postponed_notes: postponedNotes || "",
      delivered: 2,
      internal_id: selectedOrder?.internalId,
      postponed_files: postponedCurrentItemFiles,
      postponed_status: reason
    };

    try {
      const res = await Auth.fetch("/driverapp/change-order-postponed-status", {
        method: "POST",
        body: JSON.stringify(postponeData),
      });
      if (res?.ack) {
        const uploadPromises = postponedfiles.map(async (f) => {
          try {
            const uploadUrl = await getUploadUrlPostpone(f);
            await uploadFileToS3Postpone(uploadUrl, f.file, f.file.type);
          } catch (error) {
            setLoadMessage("Error uploading file:");
            setType("error");
            console.error("Error uploading file:", error);
          }
        });
        Promise.all(uploadPromises).then(() => {
          setIsModalOpen(false);
          navigate("/routes");
          setIsLoading(false);
        });
      } else {
        setLoadMessage(res?.message);
        setType("error")
      }
    } catch (err) {
      console.log('error', err);
    } finally {
      setIsLoading(false);
    }
  };

  const customerUrl = config.env === 'prod'
    ? `https://driver.magnarouting.com/customer-order/${securityCode}`
    : `http://uat.driver.magnarouting.com/customer-order/${securityCode}`;

  const deliveryContact = form.getFieldValue('deliveryContact');
  const customerContact = form.getFieldValue('customerContact');
  const whatsappContact = form.getFieldValue('whatsappContact');


  const getOutStandingBalance = async (customerID) => {
    setIsLoadingBalance(true);

    try {
      const res = await Auth.fetch(`/p/get-customer-balance?id=${customerID}`);
      if (res?.ack) {
        const totalBalance = Number(res?.balance) + Number(res?.unbilledOrders);
        form.setFieldsValue({
          outstandingBalance: totalBalance,
        })
        setOutStandingValue(totalBalance)
        setCreditLimit(res?.creditLimit)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingBalance(false);

    }
  };

  useEffect(() => {
    if (selectedOrder) {
      getOutStandingBalance(selectedOrder?.customer_internal_id)
    }
  }, [selectedOrder])

  const items = [
    {
      key: 1,
      // label: "Online",
      label: <span style={{ fontSize: '18px', padding: '12px' }}>Online</span>,
      onClick: () => {
        requestDeliveryChargeDiscount(2);
        setPaymentDiscountStatus(1);
      },
    },
    {
      key: 2,
      // label: "Non Payment",
      label: <span style={{ fontSize: '18px', padding: '12px' }}>Non Payment</span>,
      onClick: () => {
        requestDeliveryChargeDiscount(3);
        setPaymentDiscountStatus(1);
      },
    },
    {
      key: 3,
      // label: "Partial payment",
      label: <span style={{ fontSize: '18px', padding: '12px' }}>Partial Payment</span>,
      onClick: () => {
        requestDeliveryChargeDiscount(4);
        setPaymentDiscountStatus(1);
      },
    }
  ];

  return (
    <>
      <div className={classes.dataSheet}>
        <Row style={{ display: "flex", justifyContent: 'space-between' }}>
          <Button size="large" icon={<ArrowLeftOutlined />} onClick={() => navigate("/routes")}>Back</Button>
          {/* <h2 style={{ margin: '' }}>Invoice</h2> */}
          <div style={{ display: "flex", }}>
            {isLoadingBalance ? (

              <Skeleton.Input active style={{ width: '260px' }} size="large" />

            ) : (

              <Tag style={{ fontSize: '18px', height: '40px', alignContent: 'center', fontWeight: 300 }} color={
                outStandingValue > creditLimit
                  ? 'red'
                  : outStandingValue >= 0.8 * creditLimit
                    ? '#FFBF00'
                    : 'grey'
              }>
                Outstanding Balance: <span style={{ fontWeight: 500 }}>{formatCurrency(outStandingValue)}</span>
              </Tag>

            )}


            <Button ghost type="primary" style={{ marginLeft: "10px" }} size="large" onClick={() => setBankIsModalOpen(true)} icon={<InfoCircleOutlined />}>
              Bank Info
            </Button>
          </div>
          {showQR && (<div style={{ height: "auto", margin: "0 0", maxWidth: 100, width: "100%" }}>
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={customerUrl}
              viewBox={`0 0 256 256`}
            />
          </div>)}
        </Row>
        <div style={{ marginTop: '0px', marginBottom: '0px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>

          <Tag bordered={false} style={{ fontSize: '24px', height: '40px', alignContent: 'center', fontWeight: 300 }} color="blue">
            <span style={{ fontWeight: 'bold' }}>{`Drop No. `}<span style={{ fontWeight: 'bolder' }}>{selectedOrder?.rank}</span></span>
          </Tag>
          <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
            {/* {isLoadingBalance ? (
              
                <Skeleton.Input active style={{ width: '260px'}} size="large"/>
            
            ):(
              
                      <Tag style={{ fontSize: '18px', height: '40px' , alignContent: 'center', fontWeight: 300 }}  color={
                        outStandingValue > creditLimit
                          ? 'red'
                          : outStandingValue >= 0.8 * creditLimit
                          ? '#FFBF00'
                          : 'grey'
                      }>
                  Outstanding Balance: <span style={{ fontWeight: 500 }}>{formatCurrency(outStandingValue)}</span>
                    </Tag>
            
            )} */}
            {(selectedOrder?.delivered == "0" || selectedOrder?.delivered == null || selectedOrder?.delivered == undefined) && (

              <Button disabled={readOnly} type="primary" size="large" onClick={() => setIsModalOpen(true)}>
                Postpone
              </Button>
            )}
            {selectedOrder?.delivered == "2" && (
              <>
                {/* <div className="page-header"> */}
                <Popconfirm
                  title="Unpostpone Order"
                  description="Are you sure you want to Un Postpone This order?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={unpostponeOrder}
                  placement="topLeft"
                  okButtonProps={{ style: { height: "40px", width: '80px', fontSize: '16px' } }}
                  cancelButtonProps={{ style: { height: "40px", width: '80px', fontSize: '16px' } }}
                >
                  <Button disabled={readOnly} loading={isLoading} type="primary"
                    size="large"
                  >
                    Un Postpone
                  </Button>
                </Popconfirm>
                {/* </div> */}
              </>
            )}
            {/* <Button ghost type="primary" style={{ marginLeft: "10px"}} size="large" onClick={() => setBankIsModalOpen(true)} icon={<InfoCircleOutlined />}>
              Bank Info
        </Button> */}
          </div>

        </div>

        {selectedOrder?.delivered == "2" && (
          <div className={classes.postponeReason}>
            <h3>Postponment Details</h3>
            <Row gutter={[16, 4]}>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                  Reason
                </h4>
                <Select
                  style={{
                    width: "100%",
                  }}
                  size="large"
                  value={reason}
                  placeholder="Select Postponmnet Reason"
                  onChange={(value) => {
                    setReason(value);
                  }}
                >
                  {PostponeReasons.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.title}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>Notes</h4>
            <div style={{ marginBottom: "10px" }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <TextArea
                    autoSize={{ minRows: 3, maxRows: 6 }}
                    label="Notes"
                    placeholder="Enter Any Specific Notes"
                    onChange={(e) => setPostponedNotes(e.target.value)}
                    value={postponedNotes}
                  />
                </Col>
              </Row>
            </div>
            <>
              <div>
                <UploadButton
                  component="label"
                  variant="contained"
                  sx={{ marginTop: "10px" }}
                  startIcon={<CloudUploadIcon />}
                >
                  Add Postponment files
                  <input
                    type="file"
                    hidden
                    multiple
                    capture
                    accept="image/*, video/*"
                    onChange={(e) => {
                      handleSubmitImagePostpone(e);
                    }}
                  />
                </UploadButton>
              </div>
              {postponedCurrentItemFiles?.length > 0 && <h4>Postpone Current Files:</h4>}
              <Image.PreviewGroup>
                {postponedCurrentItemFiles?.length > 0 &&
                  postponedCurrentItemFiles
                    .filter((item) => !postponedfiles.some((file) => file.name === item))
                    .map((item) => {
                      const encodedItem = encodeURIComponent(item);
                      const imageUrl = `${config.tms_uploads_cdn}/${config.env}/postpone_order/${selectedRoute}/${encodedItem}`;
                      return (
                        <div
                          style={{
                            position: "relative",
                            marginRight: "10px",
                            display: "inline-block",
                          }}
                        >
                          <Image
                            width={200}
                            height={150}
                            style={{ padding: "5px", border: "1px solid lightgrey" }}
                            src={imageUrl}
                          />
                          <Tooltip title="Delete">
                            <CloseOutlined
                              style={{
                                fontSize: "30px",
                                position: "absolute",
                                right: 5,
                                top: 5,
                                color: "#c12828",
                              }}
                              onClick={() => handleDeleteCurrentFilePostpone(item)}
                            />
                          </Tooltip>

                        </div>
                      );
                    })}
              </Image.PreviewGroup>
              <Divider />
              {postponedfiles?.length > 0 && <h4>New Postpone Files:</h4>}
              <Image.PreviewGroup>
                {postponedfiles?.length > 0 &&
                  postponedfiles.map((files) => {
                    return (
                      <div
                        style={{
                          position: "relative",
                          marginRight: "10px",
                          display: "inline-block",
                        }}
                      >
                        <Image
                          width={200}
                          height={150}
                          style={{ padding: "5px", border: "1px solid lightgrey" }}
                          src={URL.createObjectURL(files.file)}
                        />
                        <Tooltip title="Delete">
                          <CloseOutlined
                            style={{
                              fontSize: "30px",
                              position: "absolute",
                              right: 5,
                              top: 5,
                              color: "#c12828",
                            }}
                            onClick={() => handleDeleteFilePostpone(files.name)}
                          />
                        </Tooltip>
                      </div>
                    );
                  })}
              </Image.PreviewGroup>
            </>
            <Row style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button loading={isLoading} type="primary" onClick={handleOk}>Update Postpone Details</Button>
            </Row>
          </div>
        )}
        <Form
          layout={"vertical"}
          form={form}
          className={classes.labels}
          style={{ padding: "10px" }}
        >
          <Row className={classes.disableInputs} gutter={[16, 4]}>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
              <Form.Item label="Order No." name="invoiceNo">
                <Input size="large" defaultValue={"abc"} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
              <Form.Item label="Shop Code" name="shopCode">
                <Input size="large" defaultValue={"abc"} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
              <Form.Item label="Terms" name="terms">
                <Input size="large" defaultValue={"abc"} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
              <Form.Item label="Post Code" name="postCode">
                <Input size="large" defaultValue={"abc"} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Form.Item label="Shop Name" name="customerName">
                <Input size="large" defaultValue={"abc"} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <Form.Item label="Address" name="address">
                <Input size="large" defaultValue={"abc"} disabled />
              </Form.Item>
            </Col>
            <>

              {customerContact && (
                <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                  <Form.Item label="Customer Number" name="customerContact">
                    <Input
                      size="large"
                      placeholder="Contact Number"
                      className={classes.phone}
                      addonAfter={
                        <PhoneFilled
                          style={{
                            fontSize: "45px",
                            color: !customerContact ? 'grey' : '#1890ff'
                          }}
                          disabled={!customerContact}
                          onClick={() => {
                            if (customerContact) {
                              window.location.href = `tel:${customerContact}`;
                            }
                          }}
                        />
                      }
                      disabled={!customerContact}
                      readOnly
                    />
                  </Form.Item>
                </Col>
              )}
              {deliveryContact && (
                <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                  <Form.Item label="Delivery Number" name="deliveryContact">
                    <Input
                      size="large"
                      placeholder="Contact Number"
                      className={classes.phone}
                      addonAfter={
                        <PhoneFilled
                          style={{
                            fontSize: "45px",
                            color: !deliveryContact ? 'grey' : '#1890ff'
                          }}
                          disabled={!deliveryContact}
                          onClick={() => {
                            if (deliveryContact) {
                              window.location.href = `tel:${deliveryContact}`;
                            }
                          }}
                        />
                      }
                      disabled={!deliveryContact}
                      readOnly
                    />
                  </Form.Item>
                </Col>
              )}
              {whatsappContact && (
                <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                  <Form.Item label="WhatsApp Number" name="whatsappContact">
                    <Input
                      size="large"
                      placeholder="Contact Number"
                      className={classes.phone}
                      addonAfter={
                        <PhoneFilled
                          style={{
                            fontSize: "45px",
                            color: !whatsappContact ? 'grey' : '#1890ff'
                          }}
                          disabled={!whatsappContact}
                          onClick={() => {
                            if (whatsappContact) {
                              window.location.href = `tel:${whatsappContact}`;
                            }
                          }}
                        />
                      }
                      disabled={!whatsappContact}
                      readOnly
                    />
                  </Form.Item>
                </Col>
              )}
            </>



          </Row>
          <Row gutter={[16, 4]}>
            <>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                {form.getFieldValue("instructionsDelivery") === undefined ||
                  form.getFieldValue("instructionsDelivery").trim() === "" ? null : (

                  <Form.Item label="Delivery Instructions" name="instructionsDelivery">
                    <TextArea disabled autoSize={{ minRows: 1, maxRows: 6 }} />
                  </Form.Item>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                {form.getFieldValue("instructionsParking") === undefined ||
                  form.getFieldValue("instructionsParking").trim() === "" ? null : (

                  <Form.Item label="Parking Instructions" name="instructionsParking">
                    <TextArea disabled autoSize={{ minRows: 1, maxRows: 6 }} />
                  </Form.Item>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                {form.getFieldValue("instructionsPayment") === undefined ||
                  form.getFieldValue("instructionsPayment").trim() === "" ? null : (

                  <Form.Item label="Payment Instructions" name="instructionsPayment">
                    <TextArea disabled autoSize={{ minRows: 1, maxRows: 6 }} />
                  </Form.Item>
                )}
              </Col>
              {/* {deliveryInstructions && (
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label="Delivery Instructions" name="instructionsDelivery">
                    <TextArea disabled autoSize={{ minRows: 1, maxRows: 6 }} />
                </Form.Item>
            </Col>
        )} */}
              {/* {parkingInstructions && (
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label="Parking Instructions" name="parkingInstructions">
                    <TextArea disabled autoSize={{ minRows: 1, maxRows: 6 }} />
                </Form.Item>
            </Col>
        )} */}
              {/* {paymentInstructions && (
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label="Payment Instructions" name="payment_instructions">
                    <TextArea disabled autoSize={{ minRows: 1, maxRows: 6 }} />
                </Form.Item>
            </Col>
        )} */}
            </>
          </Row>
          <Row className={classes.disableInputs} gutter={[16, 16]}>
            <Col xs={24} sm={12} md={12} lg={16} xl={16}>

              {form.getFieldValue("deliveryInstructions") === undefined ||
                form.getFieldValue("deliveryInstructions").trim() === "" ? null : (
                <Form.Item label="Delivery Notes" name="deliveryInstructions">
                  <TextArea disabled autoSize={{ minRows: 4, maxRows: 6 }} />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row className={classes.disableInputs} gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <Form.Item label="Invoice Total (£)" name="total">
                <Input size="large" defaultValue={"abc"} disabled />
              </Form.Item>
            </Col>
          </Row>
          {/* <Divider /> */}
        </Form>
        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>

          <h2>Items List</h2>
          {/* <Button type="primary" onClick={handleSelectAllFull}>All Items Full</Button> */}
          <FormControlLabel
            control={
              <MUICheckbox
                sx={{ padding: "0px 12px 0px 9px" }}
                style={{
                  transform: "scale(1)",
                }}
                onClick={(e) => handleSelectAllFull(e.target.checked)}
                size="large"
              />
            }
            label="Full Order Delivery"
            disabled={readOnly || !selectedOrder?.delivered == 0}
          />
        </div>
        <Table
          columns={itemColumns}
          // dataSource={selectedOrder?.items}
          dataSource={selectedOrder?.items?.filter(
            (item) => item.itemCode !== "Delivery Charge"
          )}
          pagination={false}
          style={{ overflowX: "auto", marginTop: "10px", marginBottom: "10px" }}
          footer={() => {
            const deliveryChargeItem = selectedOrder?.items?.find(
              (item) => item.itemCode === "Delivery Charge"
            );
            return deliveryChargeItem
              ? (
                <div>
                  {
                    deliveryChargeItem.unitPrice > 0 && (
                      <Tag style={{ height: '40px', alignContent: 'center', fontWeight: 400 }} color="grey">
                        <span style={{ fontSize: '18px' }}>{`Delivery Charges: ${'£' + deliveryChargeItem.unitPrice}`}
                          <span style={{ fontSize: '14px', fontWeight: 'bolder' }}> Incl. VAT</span>
                        </span>
                      </Tag>
                    )
                  }
                </div>
              ) : (
                <Tag color="grey" style={{ fontSize: '18px', height: '40px', alignContent: 'center', fontWeight: 400 }}>No Delivery Charges</Tag>
              )
          }}
        />
        {selectedOrder?.items?.some((item) => item.itemCode === "Delivery Charge") && (
          <div style={{ display: 'flex', alignItems: 'center' }}>

            <div style={{ marginTop: '40px' }} className={classes.CheckboxInputs}>
              <FormControlLabel
                control={
                  <MUICheckbox
                    sx={{
                      padding: "0px 12px 0px 14px", '&.Mui-disabled': {
                        color: 'black',
                      },
                    }}
                    style={{
                      transform: "scale(1.5)",
                    }}
                    onClick={handleWaveCharges}
                    checked={deliveryChargeDiscount}
                    size="large"
                  />
                }
                label="Delivery Charge Discount"
                disabled={readOnly || selectedOrder?.delivered == 1 || disableDiscountCheck || deliveryChargeStatus == 2 || deliveryChargeStatus == 1 || deliveryChargeStatus == 3 || selectedOrder?.delivered == -1}
              />
            </div>
            <div>
              {
                deliveryChargeDiscount && deliveryChargeStatus != 1 && deliveryChargeStatus != 2 && deliveryChargeStatus != 3 && (
                  <>
                    <Button disabled={readOnly || selectedOrder?.delivered == 2} onClick={() => {
                      requestDeliveryChargeDiscount(1)
                      setDisableDiscountCheck(true)
                    }}
                      style={{ marginRight: '5px', marginTop: '40px' }} size="large" type="primary">
                      Send Request
                    </Button>
                  </>
                )
              }
            </div>
            <div >
              {
                deliveryChargeDiscount && deliveryChargeStatus === 3 && (
                  <>
                    <Button disabled={readOnly || selectedOrder?.delivered == 2} onClick={() => { requestDeliveryChargeDiscount(1) }} style={{ marginRight: '5px', marginTop: '40px' }} size="large" type="primary">
                      Resend Request
                    </Button>
                  </>
                )
              }
            </div>
            <div className={classes.disableInputs} style={{ marginRight: '5px' }}>
              {
                deliveryChargeDiscount && (
                  // <Row>
                  //   <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                  <>

                    <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                      Authorized By
                    </h4>
                    <Select
                      style={{
                        width: "220px",
                        marginRight: '5px'
                      }}
                      size="large"
                      value={authBy}
                      placeholder=" Authorizer"
                      onChange={(value) => {
                        setAuthBy(value);
                      }}

                      // disabled={readOnly || selectedOrder?.delivered == 2}
                      disabled

                    >
                      {selectedOrder?.paymentAuthorizer.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {`${item.first_name} ${item.last_name}`}
                        </Option>
                      ))}
                    </Select>
                    {/* </Col>
             </Row> */}
                  </>
                )
              }
            </div>
            <div className={classes.disableInputs}>
              {
                deliveryChargeDiscount && (
                  <>
                    <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                      Authorizer Notes
                    </h4>
                    <TextArea autoSize disabled value={deliveryChargeNotes || ""} placeholder="Notes.." style={{ marginRight: '5px', marginTop: '0px' }} size="large" />
                  </>
                )
              }
            </div>
            <div>
              {
                deliveryChargeDiscount && deliveryChargeStatus === 2 && (
                  <>
                    {/* <Button style={{marginLeft: '5px', marginTop: '40px' }} size="large" type="primary">
              Send Request
            </Button> */}
                    {/* <CheckOutlined style={{marginLeft: '5px', marginTop: '40px', color: 'green', fontSize: '40px' }} /> */}
                    <Tag style={{ marginLeft: '5px', marginTop: '40px', fontSize: '20px', height: '40px', alignContent: 'center', fontWeight: 500 }} color={"#87d068"} >
                      {'Approved'}
                    </Tag>
                  </>
                )
              }
            </div>
            <div>
              {
                deliveryChargeDiscount && deliveryChargeStatus === 3 && (
                  <>
                    <Tag style={{ marginLeft: '5px', marginTop: '40px', fontSize: '20px', height: '40px', alignContent: 'center', fontWeight: 500 }} color={"#F32013"} >
                      {'Rejected'}
                    </Tag>
                  </>
                )
              }
            </div>
            <div>
              {
                deliveryChargeDiscount && deliveryChargeStatus === 1 && (
                  <>
                    <Tag icon={<SyncOutlined spin />} style={{ marginLeft: '5px', marginTop: '40px', fontSize: '20px', height: '40px', alignContent: 'center', fontWeight: 500 }} color={"#F0D500"} >
                      {'Pending'}
                    </Tag>
                  </>
                )
              }
            </div>
          </div>
        )}

        <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
          Driver Notes
        </h4>
        <div className={classes.disableInputs}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <TextArea
                autoSize={{ minRows: 3, maxRows: 6 }}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                label="Notes"
                placeholder="Enter Any Specific Notes"
                disabled={readOnly || selectedOrder?.delivered == 2}
                style={{
                  backgroundColor:
                    selectedOrder?.delivered === 1 || selectedOrder?.delivered === -1 ? "#e6f7ff" : "",
                  borderColor:
                    selectedOrder?.delivered === 1 || selectedOrder?.delivered === -1 ? "#1890ff" : "", // Change border color for editable
                  boxShadow:
                    selectedOrder?.delivered === 1 || selectedOrder?.delivered === -1
                      ? "0 0 5px rgba(24, 144, 255, 0.5)"
                      : "",
                  transition: "all 0.3s",
                }}
              />
            </Col>
          </Row>
        </div>
        <Divider />
        <Form
          layout={"vertical"}
          form={form}
          className={classes.labels}
          style={{ padding: "20px" }}
        >
          <div className={classes.payment}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={16} md={12} lg={8} xl={8}>
                <Form.Item label="Payment To be Received (£)">
                  <Input
                    size="large"
                    value={totalPaymentToBeReceived}
                    disabled
                  />
                </Form.Item>
              </Col>
              {
                (parseFloat(accPayment) > 0 || parseFloat(cashPayment) > 0 || parseFloat(cardPayment) > 0) && (
                  <Col xs={24} sm={16} md={12} lg={8} xl={8}>
                    <Form.Item label="Remaining Amount (£)">
                      <Input
                        size="large"
                        value={remainingAmount}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                )
              }

            </Row>
          </div>
          <div className={classes.paymentMethods}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={8} xl={6}>
                <Form.Item label="Payment By Cash (£)" name="cashPayment">
                  <Input
                    placeholder="Enter Received Amount"
                    size="large"
                    type="number"
                    value={cashPayment}
                    onChange={(e) =>
                      handlePaymentTypeChange(e.target.value, "cash")
                    }
                    disabled={readOnly || selectedOrder?.delivered == 2 || selectedOrder?.delivered == 1 || selectedOrder?.delivered == -1}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={6}>
                <Form.Item label={" "}>
                  <FormControlLabel
                    control={
                      <MUICheckbox
                        size="large"
                        sx={{ padding: "0px 12px 0px 9px" }}
                        style={{
                          transform: "scale(1.5)",
                        }}
                        checked={cashFullPayment}
                        onChange={(e) =>
                          handleFullPaymentCheckbox(e.target.checked, "cash")
                        }
                      />
                    }
                    label="Full payment"
                    disabled={readOnly || selectedOrder?.delivered == 2 || selectedOrder?.delivered == 1 || selectedOrder?.delivered == -1}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={8} xl={6}>
                <Form.Item label="Payment By Card (£)" name="cardPayment">
                  <Input
                    size="large"
                    placeholder="Enter Received Amount"
                    type="number"
                    value={cardPayment}
                    onChange={(e) =>
                      handlePaymentTypeChange(e.target.value, "card")
                    }
                    disabled={readOnly || selectedOrder?.delivered == 2 || selectedOrder?.delivered == 1 || selectedOrder?.delivered == -1}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={6}>
                <Form.Item label={" "}>
                  <FormControlLabel
                    control={
                      <MUICheckbox
                        size="large"
                        sx={{ padding: "0px 12px 0px 9px" }}
                        style={{
                          transform: "scale(1.5)",
                        }}
                        checked={cardFullPayment}
                        onChange={(e) =>
                          handleFullPaymentCheckbox(e.target.checked, "card")
                        }
                      />
                    }
                    label="Full payment"
                    disabled={readOnly || selectedOrder?.delivered == 2 || selectedOrder?.delivered == 1 || selectedOrder?.delivered == -1}
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={8} xl={6}>
                <Form.Item label="Payment By Bank (£)" name="accPayment">
                  <Input
                    size="large"
                    placeholder="Enter Amount"
                    type="number"
                    value={accPayment}
                    onChange={(e) =>
                      handlePaymentTypeChange(e.target.value, "acc")
                    }
                    disabled={readOnly || selectedOrder?.delivered == 2}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={6}>
                <Form.Item label={" "}>
                  <FormControlLabel
                    disabled={readOnly || selectedOrder?.delivered == 2}
                    control={
                      <MUICheckbox
                        size="large"
                        sx={{ padding: "0px 12px 0px 9px" }}
                        style={{
                          transform: "scale(1.5)",
                        }}
                        checked={accFullPayment}
                        onChange={(e) =>
                          handleFullPaymentCheckbox(e.target.checked, "acc")
                        }
                      />
                    }
                    label="Full payment"
                  />
                </Form.Item>
              </Col>
            </Row> */}
          </div>
        </Form>
        <Divider />

        {
          (selectedOrder?.terms === "Cash on Delivery - C" || selectedOrder?.terms === "Cash on Delivery") && (
            <Row className={classes.disableInputs} gutter={[16, 16]}>
              {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}> */}
              <>
                {
                  <>

                    <Dropdown
                      disabled={
                        deliveryChargeStatus === 1 ||
                        paymentDiscountStatus === 1 ||
                        paymentDiscountStatus === 2 ||
                        !shortPayment ||
                        readOnly ||
                        !selectedOrder?.delivered == 0
                      }
                      trigger={['click']}
                      menu={
                        { items, }}
                      placement="bottomLeft"
                    >
                      <Button
                        style={{ marginTop: '40px', marginLeft: '8px' }}
                        size="large"
                        type="primary"
                      >
                        Request Payment Authorization
                      </Button>
                    </Dropdown>


                  </>
                  // <>
                  //   <Button
                  //   disabled={deliveryChargeStatus == 1 || paymentDiscountStatus == 1 || paymentDiscountStatus == 2 || !shortPayment || readOnly || selectedOrder?.delivered == 2 }
                  //    onClick={() => {
                  //      requestDeliveryChargeDiscount(2)
                  //      setPaymentDiscountStatus(1)
                  //       }} style={{ marginTop: '40px', marginLeft: '8px' }} size="large" type="primary">
                  //     Request Payment Discount
                  //   </Button>
                  // </>
                }
              </>
              {/* </Col> */}
              <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                  Authorized By
                </h4>
                <Select
                  style={{
                    width: "100%",
                  }}
                  size="large"
                  value={paymentAuthBy}
                  placeholder="Authorizer"
                  onChange={(value) => {
                    setPaymentAuthBy(value);
                  }}

                  disabled
                >
                  {selectedOrder?.paymentAuthorizer.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {`${item.first_name} ${item.last_name}`}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                  Authorizer Notes
                </h4>
                <TextArea
                  autoSize
                  placeholder="Notes"
                  disabled
                  value={paymentDiscountNotes || ""}
                  size="large"
                />
              </Col>
              <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                {
                  paymentDiscountStatus === 1 && (
                    <>
                      <Tag icon={<SyncOutlined spin />} style={{ marginTop: '40px', fontSize: '20px', height: '40px', alignContent: 'center', fontWeight: 500 }} color={"#F0D500"} >
                        {'Pending'}
                      </Tag>
                    </>
                  )
                }
                {
                  paymentDiscountStatus === 2 && (
                    <>
                      <Tag style={{ marginLeft: '5px', marginTop: '40px', fontSize: '20px', height: '40px', alignContent: 'center', fontWeight: 500 }} color={"#87d068"} >
                        {'Approved'}
                      </Tag>
                    </>
                  )
                }
                {
                  paymentDiscountStatus === 3 && (
                    <>
                      <Tag style={{ marginLeft: '5px', marginTop: '40px', fontSize: '20px', height: '40px', alignContent: 'center', fontWeight: 500 }} color={"#F32013"} >
                        {'Rejected'}
                      </Tag>
                    </>
                  )
                }
              </Col>
            </Row>
          )
        }
        <Divider />

        <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
          Receiver Name<span style={{ color: "red", fontSize: "15px" }}>*</span>
        </h4>
        <div>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={6}>
              <Input
                value={receiverName}
                onChange={(e) => setReceiverName(e.target.value)}
                placeholder="Enter receiver Name"
                disabled={readOnly || selectedOrder?.delivered == 2 || selectedOrder?.delivered == 1 || selectedOrder?.delivered == -1}
              />
            </Col>
          </Row>
        </div>

        <div
          style={{
            width: 450,
            display: "flex",
            alignItems: 'end',
            justifyContent: "space-between",
            marginTop: "15px",
          }}
        >
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Receiver Signature<span style={{ color: "red", fontSize: "15px" }}>*</span>
          </h4>
          <Button
            size="large"
            danger
            onClick={clearSignature}
          >
            Clear Signature
          </Button>
        </div>
        <div className="sign-con">
          <SignatureCanvas
            ref={signatureCanvasRef}
            value={signature}
            penColor="purple"
            canvasProps={{
              width: 450,
              height: 200,
              className: "signature-canvas",
            }}
            onEnd={saveSignature}
          />
          <div>
            {signature && <img height={150} width={250} src={signature} />}
          </div>
        </div>
        <div
          style={{
            width: 450,
            display: "flex",
            justifyContent: "space-between",
            marginTop: "15px",
          }}
        >
          {/* <Button
            disabled={readOnly || selectedOrder?.delivered == 2}
            size="large"
            onClick={clearSignature}
          >
            Clear Signature
          </Button> */}
          {/* <Button
            disabled={readOnly || selectedOrder?.delivered == 2}
            size="large"
            type="primary"
            onClick={saveSignature}
          >
            Save Signature
          </Button> */}
        </div>
        <Divider />
        <div style={{ display: "flex" }}>
          <UploadButton
            disabled={readOnly || selectedOrder?.delivered == 2}
            component="label"
            variant="contained"
            sx={{ marginTop: "10px" }}
            startIcon={<CloudUploadIcon />}
          >
            Add files
            <input
              type="file"
              hidden
              multiple
              capture
              accept="image/*, video/*"
              onChange={(e) => {
                handleSubmitImage(e);
              }}
            />
          </UploadButton>
        </div>
        {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
        <Image.PreviewGroup>
          {currentItemFiles?.length > 0 &&
            currentItemFiles
              .filter((item) => !files.some((file) => file.name === item))
              .map((item) => {
                const imageUrl = `${config.tms_uploads_cdn}/${config.env}/route_orders/${selectedRoute}/${item}`;
                return (
                  <div
                    style={{
                      position: "relative",
                      marginRight: "10px",
                      display: "inline-block",
                    }}
                  >
                    <Image
                      width={200}
                      height={150}
                      style={{ padding: "5px", border: "1px solid lightgrey" }}
                      src={imageUrl}
                    />
                    {(!readOnly || selectedOrder?.delivered == 2) && (
                      <Tooltip title="Delete">
                        <CloseOutlined
                          style={{
                            fontSize: "30px",
                            position: "absolute",
                            right: 5,
                            top: 5,
                            color: "#c12828",
                          }}
                          onClick={() => handleDeleteCurrentFile(item)}
                        />
                      </Tooltip>
                    )}
                  </div>
                );
              })}
        </Image.PreviewGroup>
        <Divider />
        {files?.length > 0 && <h4>New Files:</h4>}
        <Image.PreviewGroup>
          {files?.length > 0 &&
            files.map((files) => {
              return (
                <div
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    display: "inline-block",
                  }}
                >
                  <Image
                    width={200}
                    height={150}
                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                    src={URL.createObjectURL(files.file)}
                  />
                  <Tooltip title="Delete">
                    <CloseOutlined
                      style={{
                        fontSize: "30px",
                        position: "absolute",
                        right: 5,
                        top: 5,
                        color: "#c12828",
                      }}
                      onClick={() => handleDeleteFile(files.name)}
                    />
                  </Tooltip>
                </div>
              );
            })}
        </Image.PreviewGroup>
        {files?.length > 0 && <Divider />}
        {/* <div className={classes.CheckboxInputs}>
          <FormControlLabel
            control={
              <MUICheckbox
                sx={{ padding: "0px 12px 0px 14px", '&.Mui-disabled': {
                    color: 'black', 
                  }, }}
                onClick={handleDelivereyCheckbox}
                style={{
                  transform: "scale(1.5)",
                }}
                checked={orderCheckbox}
                size="large"
              />
            }
            label="Order Delivered"
            disabled={readOnly || selectedOrder?.delivered == 2}
          />
        </div> */}

        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <Button
            onClick={() => navigate("/routes")}
            danger
            size="large"
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
          {!readOnly ? (
            <Button
              // type="primary"
              size="large"
              loading={isLoading}
              disabled={selectedOrder?.delivered == 2}
              onClick={selectedOrder?.delivered === 1 || selectedOrder?.delivered === -1 ? handleSaveDeliveredOrder : handleSaveOrder}
              style={{ marginRight: "10px" }}
            >
              Save
            </Button>
          ) : null}
          {!readOnly ? (

            <Button
              type="primary"
              size="large"
              loading={isLoading}
              disabled={selectedOrder?.delivered == 2 || selectedOrder?.delivered == 1 || selectedOrder?.delivered == -1}
              onClick={() => {
                Modal.confirm({
                  title: 'Deliver Order',
                  centered: true,
                  content: `Are you sure you want to deliver this order? Once delivered, you will no longer be able to update items or payments. However, you can still add files and notes.`,
                  onOk: () => handleDelivered(true),
                  okText: 'Delivered',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
            >
              Complete Delivery
            </Button>
          ) : null}
        </div>

        <PostponeModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          selectedOrder={selectedOrder}
          selectedRoute={selectedRoute}
        />
        <BankInfoModal isModalOpen={isBankModalOpen} setIsModalOpen={setBankIsModalOpen} />

        {/* <PaymentDiscountModal
          isModalOpen={paymentModalOpen}
          setIsModalOpen={setPaymentModalOpen}
          setLessPayemntOption={setLessPayemntOption}
          requestDeliveryChargeDiscount={requestDeliveryChargeDiscount}
          deliveryChargeStatus={deliveryChargeStatus}
        /> */}
      </div>

      <Message type={type} msg={loadMessage} />
      <FloatButton
        description={`Total(£): ${totalPaymentToBeReceived} `}
        shape="square"
        style={{
          right: 30,
          bottom: 110,
          minWidth: '165px',
          backgroundColor: '#e0e0e0',
          background: '#e0e0e0',
        }}
      />
    </>
  );
};

export default DeliveryItem;
